/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * BehaviourTrendsCard
 *
 * @file  BehaviourTrendsCard.jsx
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import CustomCircularProgress from '../common/CustomCircularProgress ';
import {
  Root,
  Title,
  TrendsContainer,
  TrendItem,
  PercentText,
  TrendText,
  ValueText,
  DescriptionText
} from './styles/BehaviourTrendsStyle';
import mixins from '../../assets/styles/mixins.scss';

const BehaviorTrendsCard = (props) => {
  const { behaviorTrends = [], ...otherProps } = props;

  return (
    <Root>
      <Title variant="h6">
        {otherProps.textInfo.behaviourTrendsLabel}
      </Title>

      <TrendsContainer>
        {behaviorTrends.map((trend) => (
          <TrendItem key={trend.id}>
            <CustomCircularProgress
              radius={46}
              value={trend.percentage}
              color={mixins.amethyst}
              incompleteColor={mixins.incompleteProgressColor}
              borderWidth={4}
            >
              <PercentText>
                {trend.percentage}%
              </PercentText>
            </CustomCircularProgress>

            <TrendText>
              <ValueText>
                {trend.valueText}
              </ValueText>
              <DescriptionText>
                {trend.description}
              </DescriptionText>
            </TrendText>
          </TrendItem>
        ))}
      </TrendsContainer>
    </Root>
  );
};

export default BehaviorTrendsCard;

BehaviorTrendsCard.propTypes = {
  behaviorTrends: PropTypes.array.isRequired
};
